import { useModal } from "@ebay/nice-modal-react";
import { Button, Col, Row } from "antd";
import LabelValue from "components/foundation/input/LabelValue";
import BaseModal from "components/foundation/modal/BaseModal";
import React from "react";
import { GiInfo } from "react-icons/gi";
import { useNavigate } from "react-router-dom";
import { STATUSDKTTB } from "utils/Constants/Constants";
import Format from "utils/format/Format";
import ImgDetail from "./ImgDetail";
import LogDetail from "./LogDetail";

interface OrderDetailProps {
  info: any;
}

function getStatusText(type: number) {
  const typeObj = STATUSDKTTB.find(
    (item: any) => item.value === type || item.key === type,
  );
  return typeObj ? typeObj.label : "N/A";
}

function getStatusColor(status: string) {
  switch (status) {
    case "SUBMITTED":
      return "purple";
    case "WAITING":
      return "orange";
    case "INIT":
      return "blue";
    case "APPROVE":
      return "green";
    case "REJECT":
      return "red";
    default:
      return "default";
  }
}

function getSimTypeText(type: string) {
  switch (type) {
    case "SIM_VAT_LY":
      return "Sim vật lý";
    case "ESIM":
      return "ESIM";
    default:
      return "Sim vật lý";
  }
}

const OrderDetail: React.FC<OrderDetailProps> = ({ info }) => {
  const navigate = useNavigate();
  const userModal = useModal(BaseModal);

  const handleDownload = async (url: string) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();

      const objectUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = objectUrl;
      link.download = url.split("/").pop() || "download.jpg";
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(objectUrl);
    } catch (error) {
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.click();
    }
  };

  const detail = (info: any) => {
    userModal
      .show({
        title: `Xem chi tiết`,
        children: <ImgDetail img={info} />,
        footer: [
          {
            title: "Tải ảnh xuống",
            htmlType: "submit",
            className: "btn_P btn_color",
          },
          {
            title: "Đóng",
            htmlType: "button",
            type: "primary",
          },
        ],
      })
      .then((values: any) => {
        handleDownload(info);
      })
      .catch((e) => {});
  };

  const detailLog = async () => {
    userModal
      .show({
        title: `Xem chi tiết Logs`,
        children: <LogDetail info={info} />,
        className: "modal-40",
        footer: [
          {
            title: "Đóng",
            htmlType: "button",
            type: "primary",
          },
        ],
      })
      .then((values: any) => {})
      .catch((e) => {});
  };

  const handleNav = (detail: any) => {
    let trans_id;

    if (detail?.id) {
      trans_id = detail.id;
    }
    const step = detail.step;

    if (step === 0) {
      navigate(`/order/dkttb/${trans_id}`);
    } else {
      navigate(`/order/dkttb-detail/${trans_id}`);
    }
  };

  return (
    <div>
      <Row gutter={[8, 8]}>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <div className="p-[15px] md:p-[30px] bg-white rounded-3xl shadow-md">
            <div className="border-b-[3px] border-gray-300 pb-2 mb-4 flex justify-between align-center">
              <div className="text-[20px] font-bold"> Thông tin chi tiết</div>
              {info?.step !== 2 &&
                info?.status !== "SUBMITTED" &&
                info?.status !== "REJECT" && (
                  <Button
                    type="primary"
                    className="md:mt-4 mt-0"
                    onClick={() => handleNav(info)}
                  >
                    Tiếp tục
                  </Button>
                )}
            </div>
            <LabelValue
              label="Kênh bán"
              value={info?.store_name}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Thời gian tạo đơn"
              value={Format.formatFullDateTime(info?.created_at)}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Mã đơn"
              value={info?.code}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Loại sim"
              value={getSimTypeText(info?.sim_type)}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />

            <LabelValue
              label="Taskid"
              value={info?.task_id}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Số điện thoại"
              value={info?.phone_number}
              sm={9}
              bold="true"
              textSize={14}
              textAlign="right"
              mb={18}
              valueColor="green"
            />
            <LabelValue
              label="Serial"
              value={info?.serial}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Gói cước"
              value={info?.plan_name}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Tên khách hàng"
              value={info?.name}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Thời gian duyệt"
              value={Format.formatFullDateTime(info?.created_at)}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Trạng thái"
              value={getStatusText(info?.status)}
              color={getStatusColor(info?.status)}
              sm={9}
              bold="true"
              textSize={14}
              textAlign="right"
              mb={18}
              tag
            />
            <LabelValue
              label="Số tiền thanh toán"
              value={Format.Price(info?.total_amount)}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Thời gian thanh toán"
              value={Format.formatFullDateTime(info?.approved_at)}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Ghi chú"
              value={info?.note}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              type="action"
              mb={0}
              icon={GiInfo}
              onClick={() => detailLog()}
            />
          </div>
          <div className="p-[15px] md:p-[30px] bg-white rounded-3xl shadow-md mt-[20px]">
            <div className="text-[20px] font-bold border-b-[3px] border-gray-300 pb-2 mb-4">
              Chi tiết giá tiền
            </div>
            <LabelValue
              label="Phí"
              value={Format.Price(info?.price)}
              sm={9}
              bold="left"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Phí hòa mạng"
              value={Format.Price(info?.activation_fee)}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Giá phân phối"
              value={Format.Price(info?.fee)}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Gói cước"
              value={Format.Price(info?.plan_price)}
              sm={9}
              bold="left"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <hr className="!border-gray-300 pb-2 mb-2" />
            <LabelValue
              className="!text-[#FF0606]"
              label="Tổng tiền thanh toán"
              value={Format.Price(info?.total_amount)}
              sm={10}
              bold="true"
              color="#FF0606"
              textSize={14}
              textAlign="right"
              mb={0}
            />
          </div>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <div className="p-[15px] md:p-[30px] bg-white rounded-3xl shadow-md">
            <div className="text-[20px] font-bold border-b-[3px] border-gray-300 pb-2 mb-4">
              Thông tin đăng ký
            </div>
            <LabelValue
              label="Loại giấy tờ GTTT"
              value={info?.id_type}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Số GTTT"
              value={info?.id_number}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Chủ thuê bao"
              value={info?.name}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Ngày sinh"
              value={info?.dob}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Giới tính"
              value={info?.gender === "MALE" ? "Nam" : "Nữ"}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Ngày hết hạn GTTT"
              value={info?.id_expired_date}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Ngày cấp GTTT"
              value={info?.id_issued_date}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Nơi cấp GTTT"
              value={info?.id_issued_place}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Quốc gia"
              value={info?.nationality}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Tỉnh/TP quê quán"
              value={info?.province}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Quận/Huyện quê quán"
              value={info?.district}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Xã/Phường quê quán"
              value={info?.ward}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Tỉnh/TP thường trú"
              value={info?.permanent_province}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Quận/Huyện thường trú"
              value={info?.permanent_district}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />

            <LabelValue
              label="Nơi thường trú"
              value={info?.home_full_address}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />

            <LabelValue
              label="Địa chỉ thường trú"
              value={info?.permanent_address}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Địa chỉ hiện tại"
              value={info?.contact_address}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
            />
            <LabelValue
              label="Ảnh phôi sim"
              type="img"
              value={info?.sim_base_image}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
              onClick={() => detail(info?.sim_base_image)}
            />
            <LabelValue
              label="Ảnh CCCD mặt trước"
              type="img"
              value={info?.id_front_image}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
              onClick={() => detail(info?.id_front_image)}
            />
            <LabelValue
              label="Ảnh CCCD mặt sau"
              type="img"
              value={info?.id_back_image}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
              onClick={() => detail(info?.id_back_image)}
            />
            <LabelValue
              label="Ảnh chân dung"
              type="img"
              value={info?.portrait_image}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
              onClick={() => detail(info?.portrait_image)}
            />
            <LabelValue
              label="Ảnh chữ ký"
              type="img"
              value={info?.signature_image}
              sm={9}
              bold="false"
              textSize={14}
              textAlign="right"
              mb={18}
              onClick={() => detail(info?.signature_image)}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default OrderDetail;
